import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, ViewChild, Input, OnDestroy } from '@angular/core';
import { PaginationPageEvent } from '@snapon/design-system-angular';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { StorageValues } from 'src/app/modules/shared/entities/storage-values.enum';
import { AppInfoService } from 'core/app-info/app-info.service';
import { LoadingState } from 'core/common-entities/loading-state.enum';
import { ActiveTab } from 'src/app/modules/shared/entities/active-tab.enum';
import { ImportItemsQuoteService } from 'src/app/modules/shared/import-quotes-and-orders/import-items-quote.service';
import { AdvancedSearchService } from '../../services/advanced-search.service';
import { LnOrdersService } from '../services/ln-orders.service';
import { LnOrdersTemplateValues } from '../entities/ln-orders-template-values';
import { OrderList } from '../entities/order-list';

@Component({
  selector: 'app-ln-order-list',
  templateUrl: './ln-order-list.component.html',
  styleUrls: ['./ln-order-list.component.scss'],
  standalone: false
})
export class LnOrderListComponent implements OnInit, AfterViewChecked, OnDestroy {
  @Input() isOnAccountsPage: boolean;
  @Input() bpNumber: string;
  @ViewChild(MatSort) tableSort: MatSort;

  private subs = new Subscription();
  lnOrderKey = StorageValues.LnOrderKey;
  appStrings = this.appInfoService.appStrings;
  dateFormat = this.appInfoService.dateFormat;
  customerId: string;
  templateValuesResult: LnOrdersTemplateValues;
  templateValues = {};
  isLoading = true;
  pageIndex = 0;
  getListMethod;
  totalRecords = 0;
  pageSize = 15;
  pageOffset = 0;
  totalPages: number;
  isPartialLoading = false;
  orderList: OrderList[] = [];
  activeTab = ActiveTab;

  displayedColumns: string[] = [
    'salesRepresentative',
    'customerName',
    'orderNumber',
    'orderDate',
    'orderPoNumber',
    'orderStatus',
    'orderTotalAmount',
    'orderQuoteNumber',
    'print',
    'view'
  ];
  isWithRadio = false;
  dataLoaded = {
    templateValues: true,
    orders: false
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private appInfoService: AppInfoService,
    private lnOrderService: LnOrdersService,
    private advancedSearchService: AdvancedSearchService,
    private importItemsQuoteService: ImportItemsQuoteService
  ) { }

  ngOnInit() {
    this.initData();
    this.subs.add(this.activatedRoute.params.subscribe(() => this.customerId = this.activatedRoute.snapshot.paramMap.get('customerId')));
    this.subs.add(this.lnOrderService.isProcessing$.subscribe(isLoading => {
      this.isLoading = isLoading === LoadingState.loading;
      this.isPartialLoading = isLoading === LoadingState.partiallyLoaded;
    }));
    this.subs.add(this.lnOrderService.ordersList$.subscribe(lnOrderListResult => {
      this.orderList = lnOrderListResult;
      this.dataLoaded.orders = true;
    }));
    this.subs.add(this.lnOrderService.ordersCount$.subscribe(count => {
      this.totalRecords = count;
      this.totalPages = Math.ceil(count / this.pageSize);
    }));
    this.getListMethod = this.lnOrderService.getOrderList.bind(this.lnOrderService);
    this.isWithRadio = !!this.importItemsQuoteService.getDestinationQuoteId();
  }

  ngAfterViewChecked() {
    if (this.dataLoaded.templateValues) {
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  /**
   * Getting template values
   */
  initData() {
    this.lnOrderService.getTemplateValues(templateValues => {
      this.templateValuesResult = templateValues;
      this.dataLoaded.templateValues = true;
    });
  }

  /**
   * Prints an order
   * @param orderNumber - The order number
   */
  printOrder(orderNumber: string) {
    this.lnOrderService.printOrder(orderNumber);
  }

  /**
   * Loads a page
   * @param event - The page event
   */
  loadPage(event: PaginationPageEvent) {
    this.dataLoaded.orders = false;
    this.pageIndex = event.pageNumber;
    this.lnOrderService.updatePage(event.pageNumber);
    this.pageOffset = (event.pageNumber - 1) * this.pageSize;
  }

  /**
   * Reset sort indicator
   * @param sort - On init event
   */
  resetSortIndicator(sort?: MatSort) {
    this.advancedSearchService.resetSort(this.tableSort, sort);
  }

  /**
   * Sets page index to 0
   */
  resetPageIndex() {
    this.pageIndex = 0;
  }

  /**
   * Sorts records by columns
   * @param sort - The column header click event
   */
  sortData(sort: Sort) {
    if (!sort.active) {
      return;
    } else if (!sort.direction) {
      // default sort
      sort = null;
      this.lnOrderService.resetSort();
    }
    this.resetPageIndex();
    this.lnOrderService.getOrderList(null, sort);
  }
}
